module.exports = __webpack_public_path__ + "img/badge-lion-air.23db345f.svg";